import { Box, Typography } from '@mui/joy'
import { useEffect, useState } from 'react'
import { convertSecondsToMMSS } from 'utils/formatters'

interface CallDurationTimerProps {
    startedAt?: number
}
export const CallDurationTimer = ({ startedAt }: CallDurationTimerProps) => {
    const [seconds, setSeconds] = useState(startedAt ? Math.round((Date.now() - startedAt) / 1000) : 0)

    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds((prevSeconds) => prevSeconds + 1)
        }, 1000)
        return () => clearInterval(interval)
    }, [seconds])

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography level="body-sm" fontWeight="bold">
                {convertSecondsToMMSS(seconds)}
            </Typography>
        </Box>
    )
}
